import CoreForm from "../../../../../../../web-v2/components/CoreForm";
import {TextFieldController} from "../../../../../../../web-v2/components/forms/TextFieldController";
import React, {useEffect} from "react";
import {PickerFieldController} from "../../../../../../../web-v2/components/PickerFieldController";
import {UserRoles} from "../../../../../../../../store/data/users/user-roles";
import {useForm} from "react-hook-form";
import {UserManageForm} from "../../../../../../../../store/data/users/user-manage-form";
import { SwitchFieldController } from "../../../../../../../web-v2/components/SwitchFieldController";

interface FallOutManageForm {
  fallOut: any;
  onSubmit: (data: any) => void;
}

export default function FallOutManageForm({fallOut, onSubmit}: FallOutManageForm) {
  const form = useForm<FallOutManageForm>({
    defaultValues: {
      id: null,
      fallOutCode: "",
    }
  });

  useEffect(() => {
      if (fallOut != null) {
        form.setValue("id", fallOut.id);
        form.setValue("fallOutCode", fallOut.fallOutCode);
      }
    }, [fallOut])



  const handleOnSubmit = () => {
    form.handleSubmit(onSubmit)();
  }
  

  return (
    <CoreForm form={form} onSubmit={handleOnSubmit}>
      <CoreForm.Row>
        <TextFieldController
          controlName='fallOutCode'
          title='Fault Code'
          required
        />
        
      </CoreForm.Row>
    </CoreForm>
  )
}
